"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import e from "../components/Icon/SvgIcon.js";
const i = (l) => /* @__PURE__ */ o(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.703 22h6.914a.625.625 0 0 0 0-1.25h-6.91a3.49 3.49 0 0 1-3.457-3.453V6.746a3.45 3.45 0 0 1 1.004-2.464 3.45 3.45 0 0 1 2.45-1.032h6.913a.625.625 0 0 0 0-1.25H8.7a4.7 4.7 0 0 0-3.335 1.403A4.7 4.7 0 0 0 4 6.75v10.551c.014 2.575 2.122 4.683 4.703 4.699M16.05 8.848l4.143 2.521c.45.315.45.99 0 1.261l-4.143 2.521c-.495.271-1.126-.045-1.126-.63v-1.52H9.317a1 1 0 1 1 0-2h5.607V9.476c0-.585.63-.9 1.126-.629",
        clipRule: "evenodd"
      }
    )
  }
), c = t(i);
export {
  c as SignOut,
  c as default
};
